export const buildConfig={date:"Thu Feb 27 21:13:42 GMT 2025"}
